module.exports = require('./helpers/bundle-url').getBundleURL('7oLsE') + "logo-dark.eefe0b7f.svg";